import { api } from '../api';
export default {
  indicativeQuote: (body) => api.post('/v1/finance/indicative-quote', body).then(r => r.data),
};
